import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

const apiPrefix = '/user-mgmt/v1/';

const routes = {
    getRoles: (page: number, size: number) => apiPrefix + `roles?page=${page}&size=${size}`,
    getRoleByRoleId: (roleId: any) => apiPrefix + `roles/${roleId}`,
    roles: () => apiPrefix + `roles`,
    parentRoles: () => apiPrefix + `parent-roles`,
};

@Injectable({
    providedIn: 'root'
})
export class RolesMgmtService {

    constructor(private http: HttpClient) {
    }

    getPaginatesRoles(page: number, size: number) {
        const $roles: Observable<any> = this.http
            .get(routes.getRoles(page, size))
            .pipe(
                map((roles) => {
                    return roles as any;
                })
            );

        return $roles;
    }

    getRoleByRoleId(roleId: any) {
        const $role: Observable<any> = this.http
            .get(routes.getRoleByRoleId(roleId))
            .pipe(
                map((role) => {
                    return role as any;
                })
            );
        return $role;
    }

    createRole(roleRequest: any) {
        const $role: Observable<any> = this.http
            .post(routes.roles(), roleRequest)
            .pipe(
                map((role) => {
                    return role as any;
                })
            );
        return $role;
    }

    updateRole(roleRequest: any) {
        const $role: Observable<any> = this.http
            .put(routes.roles(), roleRequest)
            .pipe(
                map((role) => {
                    return role as any;
                })
            );
        return $role;
    }

    getParentRoles() {
        const $parentRoles: Observable<any> = this.http
            .get(routes.parentRoles())
            .pipe(
                map((parentRoles) => {
                    return parentRoles as any;
                })
            );
        return $parentRoles;
    }
}
